<template>
  <div class="page_four" >
    <div class="page_two_title flex-eju-center">
      <div class="title_word">
        线索中心
        <div class="line_block"></div>
      </div>
    </div>
    <div class="page_four_content flex-eju-center">
      <div class="content_left animate__animated animate__fadeInLeft">
        <div class="left_item" :class="[index === activeIndex ? 'active' : '']" v-for="(item, index) in listData" :key="index" @click="changeItem(index)">
          <div class="title">{{item.title}}</div>
          <div class="tip">{{item.tip}}</div>
        </div>
      </div>
      <div class="content_right">
        <div v-for="(item, index) in listData" :key="index">
          <div class="right_item animate__animated" :class="[item.animate]"  v-if="index === activeIndex">
            <img :src="item.img" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    activePageIndex: {
      type: Number,
      default: 0
    }
  },
  watch: {
    activePageIndex: {
      handler: function(val) {
        if (val === 3) {
          this.showPage = true
        }
      },
    }
  },
  data() {
    return {
      showPage: false,
      activeIndex: 0,
      listData: [
        {
          title: '大数据楼盘、交易、媒体库',
          tip: '覆盖356个城市数据、交易数据6700万+条、地产文章总量1.15亿篇幅',
          img: require("@/assets/svg/page_4/P1.svg"),
          animate: 'animate__fadeInRight'
        },
        {
          title: 'AI关键词分析、投放关键词提炼',
          tip: '大数据+AI技术，深度挖掘客户需求关键词，准确、高效、迅速地处理非结构化文本信息',
          img: require("@/assets/svg/page_4/P2.svg"),
          animate: 'animate__fadeInUp'
        },
        {
          title: '全链路、全平台精准投放与搜索引擎营销',
          tip: '微信、头条、百度等矩阵式投放，基于关键词投放技术，精准高效，转化率超行业竞品 30%',
          img: require("@/assets/svg/page_4/P3.svg"),
          animate: 'animate__fadeInDown'
        },
        {
          title: '按需购买，效果监控、打通企业客户池',
          tip: '采用充值模式，即冲即投放，实时效果反馈，线索源源不断，完善的线索分配，跟进机制与客户池打通',
          img: require("@/assets/svg/page_4/P4.svg"),
          animate: 'animate__fadeInLeft'
        },
      ]
    }
  },
  methods: {
    changeItem(index) {
      if (this.activeIndex === index) return;
      this.activeIndex = index;
    }
  }
}
</script>
<style lang="less" scoped>
.page_four {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding-top: 10%;
  position: relative;
  overflow: hidden;
  &::before {
    position: absolute;
    content: " ";
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url("../../../assets/svg/chart-bg.svg");
    background-size: 100%;
    background-position: center;
    opacity: 0.1;
  }
  .page_two_title {
    font-weight: 300;
    font-size: 40px;
    line-height: 56px;
    color: #fff;
    margin-bottom: 80px;
    .title_word {
      position: relative;
      padding-bottom: 16px;
      .line_block {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 4px;
        background: linear-gradient(105.88deg, #007aff 0%, #0057ff 100%);
        border-radius: 4px;
      }
    }
  }
  .page_four_content {
    .left_item {
      width: 422px;
      height: 88px;
      box-sizing: border-box;
      border-left: 2px solid rgba(255, 255, 255, 0.5);
      padding-left: 20px;
      color: #fff;
      margin-bottom: 40px;
      cursor: pointer;
      &.active {
        border-color: #007AFF;
      }
      .title {
        font-weight: 500;
        font-size: 18px;
        line-height: 32px;
        margin-bottom: 8px;
      }
      .tip {
        font-size: 14px;
        line-height: 24px;
      }
    }
  }
  .content_right {
    margin-left: 75px;
    .right_item {
      width: 600px;
      img {
        width: 100%;
      }
    }
  }


}
</style>
